/** @jsx jsx */
import { jsx, Stack } from '@front10/base-elements';
import { Icon, IconName } from '../../../packages/base-elements/Icon/Icon';
import { useTranslation } from '@front10/utils';
import { Tab } from '@reach/tabs';

export function BookingTab(props: { labelKey: string; defaultLabel: string; icon: IconName }) {
  const translate = useTranslation();
  return (
    <Tab sx={{ flex: 1 }}>
      <Stack align="center" gap="3px">
        <Icon size={20} icon={props.icon} />
        <span>{translate(props.labelKey, props.defaultLabel)}</span>
      </Stack>
    </Tab>
  );
}
